export default __webpack_public_path__ + "static/media/e-English_banner.75a511a8.png";